import React, { useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalSyncNIB = ({ showSync, handleCloseSync }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [valueNib, setValueNib] = useState(null)
    const onChangeValueNib = e => {
        setValueNib(e.target.value)
    }

    const handleClickClose = () => {
        setValueNib(null)
        handleCloseSync()
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showSyncSuccess, setShowSyncSuccess] = useState(false)
    const [showSyncFailed, setShowSyncFailed] = useState(false)
    const [showConfirmSync, setShowConfirmSync] = useState(false)

    const handleShowConfirmSync = () => {
        setShowConfirmSync(true)
    }

    const handleCloseConfirmSync = () => setShowConfirmSync(false)

    const handleClickSync = async () => {
        setLoadingProses(true)
        try {
            const response = await pbumkuService.syncNibFromOss(valueNib)
            console.log(response)
            setShowConfirmSync(false)
            setShowSyncSuccess(true)
        } catch (error) {
            setShowConfirmSync(false)
            setShowSyncFailed(true)
        }
        setLoadingProses(false)
    }

    const handleCloseSyncSuccess = () => {
        setShowSyncSuccess(false)
        handleCloseSync()
    }

    const handleCloseSyncFailed = () => {
        setShowSyncFailed(false)
    }

    return (
        <>
            <Modal
                show={showSync}
                onHide={handleCloseSync}
                size="sm"
                centered
            >
                <Modal.Header><Modal.Title><h6>Tarik Data OSS</h6></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">NIB</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={valueNib} onChange={onChangeValueNib} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleShowConfirmSync()}>Proses</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSync &&
                <SweetAlert
                    title="Tarik Data NIB?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Synchronize...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSync}
                    onCancel={handleCloseConfirmSync}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Synchronize data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSyncSuccess &&
                <SweetAlert
                    success
                    title="Synchronize NIB Berhasil"
                    onConfirm={handleCloseSyncSuccess}
                    btnSize="sm"
                />
            }
            {
                showSyncFailed &&
                <SweetAlert
                    danger
                    title="Synchronize NIB Gagal"
                    onConfirm={handleCloseSyncFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSyncNIB